import React, { useEffect } from 'react';
import { useEventContext } from '@providers/EventProvider';
import { useMytaverseEvent } from '@core/dashboard/providers';
import MobileExternalKeyboardDeviceControls from '@components/VideoGameCast/MobileExternalKeyboardDeviceControls';

const MobileExternalKeyboardControls = () => {
  const { isEventRun } = useEventContext();
  const { shouldConnectToConference } = useMytaverseEvent();

  const inputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEventRun && inputRef.current) {
      inputRef.current.focus();

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.blur();
        }
      }, 3000);
    }
  }, [isEventRun]);

  if (!isEventRun) {
    return null;
  }

  return (
    <>
      {shouldConnectToConference && <MobileExternalKeyboardDeviceControls />}
      <input
        type="text"
        inputMode="none"
        ref={inputRef}
        style={{ position: 'fixed', top: '-9999px', left: '-9999px' }}
      />
    </>
  );
};

export default MobileExternalKeyboardControls;
